'use strict';

const Reflux = require('@muzzylane/reflux');

const AdminAnalyticsActions = require('../actions/AdminAnalyticsActions');
const ForgeError = require('../util/error');
const ErrorConsts = require('../constants/error');
const SignInActions = require('../actions/sign_in_actions');

let adminOverviewRange = null;
let adminOverviewActInstTemplateRange = null;
let adminOverviewUsersRange = null;
let adminActInstRawDataWithError = null;
let adminActInstAnalytics = {};

let action = {};

const AdminAnalyticsStore = Reflux.createStore({
    listenables: [AdminAnalyticsActions, SignInActions],
    init: function() {},

    resetState: function() {
        adminOverviewRange = null;
        adminOverviewActInstTemplateRange = null;
        adminOverviewUsersRange = null;
        adminActInstRawDataWithError = null;
        adminActInstAnalytics = {};
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    getState: function() {
        return {
            adminOverviewRange: adminOverviewRange,
            adminOverviewActInstTemplateRange: adminOverviewActInstTemplateRange,
            adminOverviewUsersRange: adminOverviewUsersRange,
            adminActInstRawDataWithError: adminActInstRawDataWithError,
            adminActInstAnalytics: adminActInstAnalytics,
            action: action,
        };
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
    },

    onGetAdminOverviewStatsRangeCompleted: function(actionId, stats) {
        // console.log('onGetAdminOverviewStatsRangeCompleted', actionId, stats);
        action = { id: actionId };
        adminOverviewRange = stats;
        this.emitStatus();
    },

    onGetAdminOverviewStatsRangeFailed: function(actionId, err) {
        console.warn('onGetAdminOverviewStatsRangeFailed', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetAdminActInstTemplateRangeCompleted: function(actionId, stats) {
        // console.log('onGetAdminActInstTemplateRangeCompleted', actionId, stats);
        action = { id: actionId };
        adminOverviewActInstTemplateRange = stats;
        this.emitStatus();
    },

    onGetAdminActInstTemplateRangeFailed: function(actionId, err) {
        console.warn('onGetAdminActInstTemplateRangeFailed', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetAdminOverviewUsersRangeCompleted: function(actionId, stats) {
        // console.log('onGetAdminOverviewUsersRangeCompleted', actionId, stats);
        action = { id: actionId };
        adminOverviewUsersRange = stats;
        this.emitStatus();
    },

    onGetAdminOverviewUsersRangeFailed: function(actionId, err) {
        console.warn('onGetAdminOverviewUsersRangeFailed', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetAdminActInstRawDataWithErrorCompleted: function(actionId, actInstsRawData) {
        console.log('onGetAdminActInstRawDataWithErrorCompleted', actionId, actInstsRawData);
        action = { id: actionId };
        adminActInstRawDataWithError = actInstsRawData;
        this.emitStatus();
    },

    onGetAdminActInstRawDataWithErrorFailed: function(actionId, err) {
        console.log('onGetAdminActInstRawDataWithErrorFailed', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetAdminActInstAnalyticsCompleted: function(actionId, novaActInstId, actInstAnalytics) {
        console.log('onGetAdminActInstAnalyticsCompleted', actionId, novaActInstId, actInstAnalytics);
        action = { id: actionId };
        adminActInstAnalytics[novaActInstId] = actInstAnalytics;
        this.emitStatus();
    },

    onGetAdminActInstAnalyticsFailed: function(actionId, novaActInstId, err) {
        console.log('onGetAdminActInstAnalyticsFailed', actionId, novaActInstId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onRetryAdminActInstAnalyticsCompleted: function(actionId, novaActInstId, actInstAnalyticsRawData) {
        console.log('onRetryAdminActInstAnalyticsCompleted', actionId, novaActInstId, actInstAnalyticsRawData);
        action = { id: actionId };
        adminActInstRawDataWithError = adminActInstRawDataWithError.map((rd) => {
            if (rd.nova_act_inst_id === actInstAnalyticsRawData.nova_act_inst_id) {
                return actInstAnalyticsRawData;
            }

            return rd;
        });
        this.emitStatus();
    },

    onRetryAdminActInstAnalyticsFailed: function(actionId, novaActInstId, err) {
        console.log('onRetryAdminActInstAnalyticsFailed', actionId, novaActInstId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
});

module.exports = AdminAnalyticsStore;
